import { Injectable, inject, signal } from '@angular/core';
import { Firestore, collection, doc, docData } from '@angular/fire/firestore';
import { EstablishmentCheckout } from '@pedix-workspace/utils';
import { getEstablishmentCheckoutConverter } from '@pedix-workspace/shared-models';
import { AppRequestContextService } from '../../app-request-context.service';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/pedixapp/src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class EstablishmentsCheckoutService {
  private firestore = inject(Firestore);
  private appRequestContextService = inject(AppRequestContextService);
  private http = inject(HttpClient);
  private deviceService = inject(DeviceDetectorService);

  readonly checkoutData = signal<EstablishmentCheckout | null>(null);

  get collectionRef() {
    return collection(this.firestore, 'establishmentsCheckout').withConverter(
      getEstablishmentCheckoutConverter({
        features: this.appRequestContextService.establishment.features,
      }),
    );
  }

  get isInstagram() {
    return this.deviceService.userAgent.includes('Instagram');
  }

  async get(establishmentId: string): Promise<EstablishmentCheckout> {
    if (!this.checkoutData()) {
      if (this.isInstagram) {
        // NOTE: we needed to do this because in Instagram in-app browser we could not get the firestore query to resolve
        const apiUrl = `${environment.apiV1Url}/establishments/${establishmentId}/checkout`;

        const { checkoutData } = await firstValueFrom(
          this.http.get<{ checkoutData: EstablishmentCheckout }>(apiUrl),
        ).catch(error => {
          console.error('Error fetching checkout data:', error);

          return { checkoutData: null };
        });
        this.checkoutData.set(checkoutData);
      } else {
        const checkoutData = await firstValueFrom(
          docData(doc(this.collectionRef, establishmentId)),
        );

        this.checkoutData.set(checkoutData);
      }
    }

    return this.checkoutData();
  }
}
